/* ── COLOR → CAROUSEL IMAGE SYNC (v4, DOM-first, visible logs) ─────────────
   Hooks the color swatches directly (radio + label clicks, plus change).
   Resolves the selected color and moves the carousel to the matching slide:
     1. Build Color → media.id map from #productData.media (filename match).
     2. Find the slide index by [data-media-id] in the main slider
        (always present in the DOM, independent of lazy-loaded <img>).
     3. Fallback: match thumbnail nav <img> src filename (thumbnails are
        rendered eagerly at width 120), then main slider <img> src.
   Uses console.log (visible) and try/catch so nothing breaks the page.
─────────────────────────────────────────────────────────────────────────────────── */
(function () {
  function initColorSync() {
    var vpEl = document.querySelector('variant-picker');
    if (!vpEl) {
      console.log('[ColorSync] no variant-picker found');
      return;
    }
    console.log('[ColorSync] variant-picker found:', vpEl.dataset.productId);

    var pdEl = document.querySelector('#productData[type="application/json"]');
    var productData = null;
    if (pdEl) {
      try { productData = JSON.parse(pdEl.textContent); } catch (e) { productData = null; }
    }
    if (!productData) console.log('[ColorSync] no productData; will rely on DOM matching');

    /* Detect the color option position by name. */
    var colorIdx = -1;
    if (productData) {
      var owv = productData.options_with_values || [];
      for (var o = 0; o < owv.length; o++) {
        var nm = String((owv[o] && owv[o].name) || '').toLowerCase();
        if (nm === 'color' || nm === 'colour' || nm === 'colorway') { colorIdx = o; break; }
      }
      if (colorIdx < 0) {
        var opts = productData.options || [];
        for (var o2 = 0; o2 < opts.length; o2++) {
          var nm2 = String(opts[o2]).toLowerCase();
          if (nm2 === 'color' || nm2 === 'colour' || nm2 === 'colorway') { colorIdx = o2; break; }
        }
      }
    }
    if (colorIdx < 0) colorIdx = 0; /* assume first option is color as last resort */

    /* Normalize a string for filename matching. */
    function norm(s) {
      return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    /* Build Color → media.id map from #productData.media (filename matching). */
    var colorToMediaId = {};
    if (productData) {
      var medias = productData.media || [];
      var colorValues = [];
      if (productData.options_with_values && productData.options_with_values[colorIdx]) {
        colorValues = productData.options_with_values[colorIdx].values || [];
      }
      colorValues.forEach(function (colorVal) {
        if (!colorVal || colorToMediaId[colorVal]) return;
        var key = norm(colorVal);
        for (var m = 0; m < medias.length; m++) {
          var med = medias[m];
          var src = (med.preview_image && med.preview_image.src) || med.src || '';
          var file = String(src).split('?')[0].split('/').pop();
          var base = file.replace(/\.[a-z0-9]+$/i, '');
          if (norm(base) === key || norm(base).indexOf(key) !== -1 || key.indexOf(norm(base)) !== -1) {
            colorToMediaId[colorVal] = med.id;
            break;
          }
        }
      });
      if (Object.keys(colorToMediaId).length) {
        console.log('[ColorSync] colorToMediaId:', JSON.stringify(colorToMediaId));
      }
    }

    /* Read the selected color value from the color radios. */
    function getSelectedColor() {
      var radios = vpEl.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          var name = String(radios[i].name || '').toLowerCase();
          if (name === 'color' || name === 'colour' || name === 'colorway' || colorIdx === 0) {
            return radios[i].value;
          }
        }
      }
      /* fallback: any checked radio */
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].checked) return radios[j].value;
      }
      return null;
    }

    /* Find the slide index whose [data-media-id] matches (main slider). */
    function findIndexByMediaId(slides, mediaId) {
      if (!slides || mediaId == null) return -1;
      var target = String(mediaId);
      for (var i = 0; i < slides.length; i++) {
        var el = slides[i].querySelector('[data-media-id]');
        if (el && String(el.dataset.mediaId) === target) return i;
      }
      return -1;
    }

    /* Find the slide index whose <img> src filename matches a color. */
    function findIndexByFilename(slides, color) {
      if (!slides || !color) return -1;
      var key = norm(color);
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (!img || !img.src) continue;
        var file = String(img.src).split('?')[0].split('/').pop();
        var base = file.replace(/\.[a-z0-9]+$/i, '');
        if (norm(base) === key || norm(base).indexOf(key) !== -1 || key.indexOf(norm(base)) !== -1) return i;
      }
      return -1;
    }

    /* Move one gallery (main slider + thumbnail nav) to an index. */
    function goToIndex(gallery, index) {
      if (!gallery || index < 0) return;

      if (gallery.slider) {
        if (typeof gallery.slider.slideToLoop === 'function') {
          gallery.slider.slideToLoop(index);
        } else if (typeof gallery.slider.slideTo === 'function') {
          gallery.slider.slideTo(index);
        }
      }

      if (gallery.navSlider) {
        if (typeof gallery.navSlider.slideTo === 'function') {
          gallery.navSlider.slideTo(index, 300, false);
        }
        var thumbs = gallery.navSlider.slides || [];
        for (var i = 0; i < thumbs.length; i++) {
          if (i === index) {
            thumbs[i].classList.add('swiper-slide-thumb-active');
          } else {
            thumbs[i].classList.remove('swiper-slide-thumb-active');
          }
        }
      }
    }

    /* Sync every gallery to the selected color. */
    function sync() {
      try {
        var color = getSelectedColor();
        console.log('[ColorSync] sync color =', color);

        var mediaId = colorToMediaId[color];

        document.querySelectorAll('media-gallery').forEach(function (g) {
          var idx = -1;
          var slides = g.slider ? (g.slider.slides || []) : [];
          /* 1) by media-id in main slides */
          if (idx < 0) idx = findIndexByMediaId(slides, mediaId);
          /* 2) by filename in thumbnail nav (always rendered) */
          if (idx < 0 && g.navSlider) idx = findIndexByFilename(g.navSlider.slides, color);
          /* 3) by filename in main slides */
          if (idx < 0) idx = findIndexByFilename(slides, color);
          console.log('[ColorSync] media-gallery index =', idx);
          goToIndex(g, idx);
        });

        document.querySelectorAll('media-gallery-mobile').forEach(function (g) {
          var idx = -1;
          var slides = g.slider ? (g.slider.slides || []) : [];
          if (idx < 0) idx = findIndexByMediaId(slides, mediaId);
          if (idx < 0 && g.navSlider) idx = findIndexByFilename(g.navSlider.slides, color);
          if (idx < 0) idx = findIndexByFilename(slides, color);
          goToIndex(g, idx);
        });
      } catch (err) {
        console.log('[ColorSync] error:', err && err.message);
      }
    }

    /* Wait until galleries have a slider, then run sync. */
    function runSyncWhenReady(attempt) {
      var galleries = document.querySelectorAll('media-gallery, media-gallery-mobile');
      var ready = true;
      galleries.forEach(function (g) { if (!g.slider) ready = false; });
      if (ready || attempt >= 25) { sync(); return; }
      setTimeout(function () { runSyncWhenReady(attempt + 1); }, 120);
    }

    /* Hook color swatches: change on radios + click on radios and labels. */
    function hookPicker() {
      vpEl.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () { setTimeout(sync, 60); });
        radio.addEventListener('click', function () { setTimeout(sync, 60); });
      });
      vpEl.querySelectorAll('label').forEach(function (label) {
        label.addEventListener('click', function () {
          /* give the browser time to toggle the radio */
          setTimeout(sync, 80);
        });
      });
    }
    hookPicker();

    /* Also handle any radios added later (re-hook on mutations). */
    var mo = null;
    if (window.MutationObserver) {
      mo = new MutationObserver(function () { hookPicker(); });
      try { mo.observe(vpEl, { childList: true, subtree: true }); } catch (e) {}
    }

    /* Run once on load so the initial image matches the selected color. */
    setTimeout(function () { runSyncWhenReady(0); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSync);
  } else {
    initColorSync();
  }
}());
